import { IPatient } from '../interfaces'
import { PlusOutlined } from '@ant-design/icons'
import { ColumnsType } from 'antd/lib/table'
import { Button } from 'components/atoms'
import { useColumnFactory } from 'hooks'
import { t } from 'i18next'
import styled from 'styled-components'
import { formatDate } from 'utils'

const StyledBtnContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

const useColumnPatient = (onAction: (row: any) => void) => {
  const { createColumns } = useColumnFactory<any>()
  const getColumns = (): ColumnsType<IPatient> => [
    {
      title: 'patient-name',
      dataIndex: 'full_name',
      align: 'left',
      width: 200
    },
    {
      title: 'phone-number',
      dataIndex: 'phone_number',
      align: 'left',
      width: 70
    },
    {
      title: 'birthday',
      dataIndex: 'date_of_birth',
      align: 'left',
      width: 60,
      render: (value) => formatDate(value, 'DD/MM/YYYY')
    },
    {
      title: 'gender',
      dataIndex: 'gender',
      align: 'left',
      width: 50,
      render: (value) => t(`gender-${value}`)
    },
    {
      title: 'action',
      dataIndex: 'action',
      fixed: 'right',
      align: 'center',
      width: 90,
      render: (value, row) => (
        <StyledBtnContainer>
          <Button
            icon={<PlusOutlined />}
            onClick={() => onAction(row)}
            style={{ height: 32 }}
            color="green">
            {t('booking')}
          </Button>
        </StyledBtnContainer>
      )
    }
  ]

  return {
    columns: createColumns(getColumns())
  }
}

export default useColumnPatient
